<template>
  <div class="radio-wrap" @click="handleClick">
    <div class="radio-icon" :class="{'is-select':isChecked}"></div>
    <div class="radio-label">
      {{label}}
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "radio",
  data() {
    return {
      newValue: false
    };
  },
  props: {
    label: String, //文案
    name: String, //key值
    defaultValue: Boolean
  },
  created() {
    if (typeof this.defaultValue === "boolean") {
      this.newValue = this.defaultValue;
    }
  },
  computed: {
    isChecked() {
      return this.newValue;
    }
  },
  methods: {
    handleClick() {
      this.newValue = !this.newValue;
      this.$emit("change", this.newValue, {
        name: this.name,
        label: this.label
      });
    },
    select() {
      this.newValue = true;
    },
    unSelect() {
      this.newValue = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.radio-wrap {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.radio-icon {
  height: 20px;
  width: 20px;
  display: inline-block;
  position: relative;
  overflow: hidden;
  &::before {
    content: "";
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    position: absolute;
    opacity: 1;
    background-position: center;
    background-size: cover;
    background-image: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20230713114025119-icon_Chec_off.png);
  }
  &::after {
    content: "";
    height: 100%;
    width: 100%;
    opacity: 0;
    left: 0;
    top: 0;
    position: absolute;
    background-position: center;
    background-size: cover;
    background-image: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20230713114028898-icon_Chec_on.png);
  }
  &.is-select::before {
    opacity: 0;
  }
  &.is-select::after {
    opacity: 1;
  }
}
</style>